module.exports = __webpack_public_path__ + "img/BARCODE.65802c47.svg";